import type { ReactNode } from "react";
import "./RapportkatalogCardLabelAndText.css";
import { Paragraph } from "@digdir/designsystemet-react";

type RapportkatalogCardLabelAndTextProps = {
    label: string;
    value: ReactNode;
};

export function RapportkatalogCardLabelAndText({ label, value }: RapportkatalogCardLabelAndTextProps) {
    return (
        <div className="rapportkatalog-card-label-and-text">
            <Paragraph className="rapportkatalog-card-label-and-text-label">{label}</Paragraph>
            <Paragraph className="rapportkatalog-card-label-and-text-text">{value}</Paragraph>
        </div>
    );
}
